module.exports = __webpack_public_path__ + "static/media/do.1f420f66.webp";